import React from 'react';

import { bemBlock } from '../../modules/bem';

import { useTableContext } from './TableContext';

import './TableBody.less';

const block = bemBlock('table-body');

export type TableBodyProps = React.HTMLAttributes<HTMLTableSectionElement>;

export const TableBody = React.forwardRef<HTMLTableSectionElement, TableBodyProps>(
  function TableBody({ className, ...passProps }, ref) {
    const { shouldVirtualize } = useTableContext();

    return (
      <tbody
        ref={ref}
        className={block({ modifiers: { virtualized: shouldVirtualize }, extra: className })}
        {...passProps}
      />
    );
  },
);
